import { Colors, FInter, FlexBox } from "@brg/ui";
import { SubmitProjectButton } from "_competition/components/SendProjectButton";
import { LayoutConst } from "core";
import { CustomInputProps } from "shared/components/inputs/components/dropdown/Dropdown";
import styled, { css } from "styled-components";
import DateIcon from '../icons/DateIcon.svg';
import { ProjectEditPageGridLabel } from "../pages/projectEdit/styles";

export const SendButton = styled(SubmitProjectButton)`
    width: 137px;
    max-width: 137px;
    min-width: 137px;
    height: 38px;
    margin-right: 0;
    @media (max-width: ${LayoutConst.screen.s -1}px){
        width: 100%;
        max-width: none;
        min-width: 100%;
        height: 46px;
    }
`;
export const ContentContainer = styled(FlexBox)`
    margin: 0 auto 0 0;
    max-width: calc(1152px - 226px);
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: calc(888px - 160px);
    }

    @media (max-width: ${LayoutConst.screen.m}px){
        width: calc(100vw - 32px);
        max-width: none;
        margin: 0 16px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
        width: calc(100vw - 20px);
        margin: 0 auto;
    }

    input {
        color: ${(p) => p.theme.sendProjectsModal.input.color} !important;
        background-color: ${(p) => p.theme.sendProjectsModal.input.bg} !important;
        border-radius: 3px;
    }

    textarea {
        color: ${(p) => p.theme.sendProjectsModal.input.color} !important;
        background-color: ${(p) => p.theme.sendProjectsModal.input.bg} !important;
        border-radius: 3px;
        border-color: transparent;
    }
`;

export const MainTitle = styled.div`
    font-size: 43px;
    line-height: 51px;
    white-space: nowrap;
    color: ${({ theme }) => theme.sendProjectsModal.title};
    font-weight: 700;
    margin: 0 0 56px 0;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin: 0 0 48px 0;
        font-size: 34px;
        line-height: 41px;
    }

    @media (max-width: ${LayoutConst.screen.m}px){
        margin: 0 0 32px 0;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
        margin: 0 0 32px 0;
        font-size: 30px;
        line-height: 40px;
    }

`;

export const LegalsLabel = styled(FInter.SmallTextDiv)`
    width: 202px;
    font-size: 17px;
    margin-right: 24px;
    line-height: 22px;
    position: relative;
    color: ${(p) => p.theme.sendProjectsModal.label};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 140px;
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 8px;
        white-space: pre-wrap;
        width: auto;
    }
`;

export const InfoBlock = styled(FInter.SmallTextDiv)`
    font-size: 13px;
    -line-height: 16px;
    margin-left: 20%;
    margin-right: 24px;
    text-align: right;
    a {
        text-decoration: underline;
        color: ${({ theme }) => theme.sendProjectsModal.title};
    }
    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 16px;
    }
`
;

export const Wrapper = styled(FlexBox)<{ isGeo?: boolean }>`

    width: 1152px;

    input {
        font-size: 17px;
        line-height: 22px;
        height: 46px;
        min-height: 46px;
        max-height: 46px;
        width: 700px;
        max-width: 700px;
        min-width: 700px;
        background-color: #f2f2f2;
        border: 1px solid transparent;
        // &:hover {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        // &:focus {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        // &:active {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        
    }

    .date-input {
        width: 100% !important;
        height: 46px !important;

        input[value=""]::-webkit-datetime-edit {
            color: transparent;
            visibility: hidden; 
        }
        :focus::-webkit-datetime-edit{ 
            color: #151514; 
        }

        ::-webkit-calendar-picker-indicator {
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            cursor: pointer;
            background: url(${DateIcon}) no-repeat;
            width: 20px;
            height: 20px;
            border-width: thin;
        }
    }

    .brg-input__control {
        height: 46px;
        min-height: 46px;
        max-height: 46px;
    }

${({ isGeo }) => isGeo && css`
    input {
        background-color: #3F4548 !important;
    }
    input[type="date"] {
        padding-right: 12px;

        ::-webkit-calendar-picker-indicator {
            color-scheme: dark;
        }
    }
`};
      
::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 61px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
    background-clip: padding-box; /* имитация марджина */
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;


    .date-input {
        height: 40px !important;
    }
    input {
        font-size: 15px;
        line-height: 20px;
        height: 40px;
        min-height: 40px;
        max-height: 40px;
        width: 564px;
        max-width: 564px;
        min-width: 564px;
    }

    textarea {
        max-width: 564px;
        min-width: 564px;
    }

    .brg-input__control {
        height: 40px;
        min-height: 40px;
        max-height: 40px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px){
    width: 100%;

    .date-input {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
    }
  }

`;

export const FileInputWrapper = styled(FlexBox)<CustomInputProps>`
    padding: 5px;
    position: relative;
    flex-flow: column;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    height: 120px;
    background: ${(p) =>
        p.customBackgroundColor ?? p.theme.projectEdit.imgContainerBg};
`;

export const FileInput = styled.input`
    position: absolute;
    width: 100%;
    height: 100%;
    display: block !important;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
`

export const EduSecetWrapper = styled(FlexBox)`
    width: 100%;
    .select-edu {
        width: 100%;
    }

    &:hover {
        .brg-input__control {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border} !important;
        }
    }
    max-height: 48px;

    .brg-input__control {
        background-color: ${({ theme }) => theme.competitionLegalsModal.input.bg};
        border-color: ${({ theme }) => theme.competitionLegalsModal.input.defaultBorder};

        &:hover {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }
        &:focus {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }
        &:active {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }

    }

    .brg-input__indicator {
        opacity: 1 !important;
        transition: transform 0.2s !important;
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon} !important;
        }
    }

    .brg-input__menu-list {
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
        }

        ::-webkit-scrollbar {
            width: 6px; /* ширина scrollbar */
            height: 61px;
          }
          ::-webkit-scrollbar-track {
            background: transparent; /* цвет дорожки */
          }
          ::-webkit-scrollbar-thumb {
            border-radius: 3px; /* закругления плашки */
            background: #909090;
            border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
            background-clip: padding-box; /* имитация марджина */
          }
        }
    }

    .brg-input__placeholder {
        color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
    }

    .brg-input__indicators {
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
            opacity: 1 !important;
            transition: none;
        }
    }

    .brg-input__menu {
        background-color: ${({ theme }) => theme.competitionLegalsModal.input.bg};
    }

    .brg-input__single-value {
        color: ${({ theme }) => theme.competitionLegalsModal.input.color} !important;
    }

    .brg-input__option {
        color: ${({ theme }) => theme.competitionLegalsModal.input.color};
    }
`;

export const ComeAgreeInfo = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 10px;
`;

export const FormInfoTitle = styled(FlexBox)`
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: ${({ theme }) => theme.sendProjectsModal.title};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
`;

export const FormInfoDescription = styled(FlexBox)`
    font-size: 17px;
    line-height: 22px;
    display: inline-block;
    font-weight: 400;
    color: ${({ theme }) => theme.sendProjectsModal.title};

    a {
        color: ${({ theme }) => theme.sendProjectsModal.title};
        text-decoration: underline;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;


export const AgreeWrapper = styled(FlexBox)`
    margin-top: 24px;
    flex-flow: column;

    .checkbox {
        width: 24px;
        height: 24px;
        :hover {
            background: transparent;
        }
    }

    span {
        font-size: 15px;
        line-height: 20px;
        color: ${Colors.galBlack47};

        a {
            text-decoration: underline;
            color: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-top: 34px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin-top: 16px;
    }
`;

export const FormLabel = styled(ProjectEditPageGridLabel)<{ required?: boolean, nowrap?: boolean, labelWidth?: number, labelMargin?: number }>`
    ${({ labelWidth }) => labelWidth && css`
        width: ${labelWidth}px;
        min-width: ${labelWidth}px;
        max-width: ${labelWidth}px;
    `}
    margin-right: ${({ labelMargin }) => labelMargin}px;
    // align-items: flex-start;
    padding-top: 0;

    font-size: 15px;
    line-height: 20px;
    position: relative;
    min-height: 48px;

    ${({ required }) => required && css`
      &::after {
        position: absolute;
        top: 3px;
        right: 15px;
        content: ' *';
        display: contents;
        color: #C64839;
      }
    `};

    .required-label {
        &::after {
            position: absolute;
            top: 50%;
            left: 10%;
            transform: translateY(-50%);
            display: contents;
            content: ' *';
            color: #C64839;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        ${({ labelWidth }) => labelWidth && css`
            width: ${labelWidth}px;
            min-width: ${labelWidth}px;
        `}
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    }

  @media(max-width: ${LayoutConst.screen.m}px) {
    height: 20px;
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
  }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        width: 100%;
        max-width: none;
        white-space: pre-wrap !important;
        font-size: 13px;
        line-height: 16px;
        .required-label {
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                left: 102%;
                display: inline;
                content: '*';
            }
    }
    }
`;
export const FormLabelText = styled(FlexBox)<{required?: boolean}>`
    ${({ required }) => required && css`
      &::after {
        position: absolute;
        top: 3px;
        right: 15px;
        content: ' *';
        display: contents;
        color: #C64839;
      }
    `};
`import { Colors, FInter, FlexBox } from "@brg/ui";
import { SubmitProjectButton } from "_competition/components/SendProjectButton";
import { LayoutConst } from "core";
import { CustomInputProps } from "shared/components/inputs/components/dropdown/Dropdown";
import styled, { css } from "styled-components";
import DateIcon from '../icons/DateIcon.svg';
import { ProjectEditPageGridLabel } from "../pages/projectEdit/styles";

export const SendButton = styled(SubmitProjectButton)`
    width: 137px;
    max-width: 137px;
    min-width: 137px;
    height: 38px;
    margin-right: 0;
    @media (max-width: ${LayoutConst.screen.s -1}px){
        width: 100%;
        max-width: none;
        min-width: 100%;
        height: 46px;
    }
`;
export const ContentContainer = styled(FlexBox)`
    margin: 0 auto 0 0;
    max-width: calc(1152px - 226px);
    flex-flow: column;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: calc(888px - 160px);
    }

    @media (max-width: ${LayoutConst.screen.m}px){
        width: calc(100vw - 32px);
        max-width: none;
        margin: 0 16px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
        width: calc(100vw - 20px);
        margin: 0 auto;
    }

    input {
        color: ${(p) => p.theme.sendProjectsModal.input.color} !important;
        background-color: ${(p) => p.theme.sendProjectsModal.input.bg} !important;
        border-radius: 3px;
    }

    textarea {
        color: ${(p) => p.theme.sendProjectsModal.input.color} !important;
        background-color: ${(p) => p.theme.sendProjectsModal.input.bg} !important;
        border-radius: 3px;
        border-color: transparent;
    }
`;

export const MainTitle = styled.div`
    font-size: 43px;
    line-height: 51px;
    white-space: nowrap;
    color: ${({ theme }) => theme.sendProjectsModal.title};
    font-weight: 700;
    margin: 0 0 56px 0;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin: 0 0 48px 0;
        font-size: 34px;
        line-height: 41px;
    }

    @media (max-width: ${LayoutConst.screen.m}px){
        margin: 0 0 32px 0;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
        margin: 0 0 32px 0;
        font-size: 30px;
        line-height: 40px;
    }

`;

export const LegalsLabel = styled(FInter.SmallTextDiv)`
    width: 202px;
    font-size: 17px;
    margin-right: 24px;
    line-height: 22px;
    position: relative;
    color: ${(p) => p.theme.sendProjectsModal.label};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 140px;
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 8px;
        white-space: pre-wrap;
        width: auto;
    }
`;

export const InfoBlock = styled(FInter.SmallTextDiv)`
    font-size: 13px;
    -line-height: 16px;
    margin-left: 20%;
    margin-right: 24px;
    text-align: right;
    a {
        text-decoration: underline;
        color: ${({ theme }) => theme.sendProjectsModal.title};
    }
    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 16px;
    }
`
;

export const Wrapper = styled(FlexBox)<{ isGeo?: boolean }>`

    width: 1152px;

    input {
        font-size: 17px;
        line-height: 22px;
        height: 46px;
        min-height: 46px;
        max-height: 46px;
        width: 700px;
        max-width: 700px;
        min-width: 700px;
        background-color: #f2f2f2;
        border: 1px solid transparent;
        // &:hover {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        // &:focus {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        // &:active {
        //     border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};
        // }
        
    }

    .date-input {
        width: 100% !important;
        height: 46px !important;

        input[value=""]::-webkit-datetime-edit {
            color: transparent;
            visibility: hidden; 
        }
        :focus::-webkit-datetime-edit{ 
            color: #151514; 
        }

        ::-webkit-calendar-picker-indicator {
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            cursor: pointer;
            background: url(${DateIcon}) no-repeat;
            width: 20px;
            height: 20px;
            border-width: thin;
        }
    }

    .brg-input__control {
        height: 46px;
        min-height: 46px;
        max-height: 46px;
    }

${({ isGeo }) => isGeo && css`
    input {
        background-color: #3F4548 !important;
    }
    input[type="date"] {
        padding-right: 12px;

        ::-webkit-calendar-picker-indicator {
            color-scheme: dark;
        }
    }
`};
      
::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 61px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
    background-clip: padding-box; /* имитация марджина */
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;


    .date-input {
        height: 40px !important;
    }
    input {
        font-size: 15px;
        line-height: 20px;
        height: 40px;
        min-height: 40px;
        max-height: 40px;
        width: 564px;
        max-width: 564px;
        min-width: 564px;
    }

    textarea {
        max-width: 564px;
        min-width: 564px;
    }

    .brg-input__control {
        height: 40px;
        min-height: 40px;
        max-height: 40px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px){
    width: 100%;

    .date-input {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
    }
  }

`;

export const FileInputWrapper = styled(FlexBox)<CustomInputProps>`
    padding: 5px;
    position: relative;
    flex-flow: column;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    height: 120px;
    background: ${(p) =>
        p.customBackgroundColor ?? p.theme.projectEdit.imgContainerBg};
`;

export const FileInput = styled.input`
    position: absolute;
    width: 100%;
    height: 100%;
    display: block !important;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
`

export const EduSecetWrapper = styled(FlexBox)`
    width: 100%;
    .select-edu {
        width: 100%;
    }

    &:hover {
        .brg-input__control {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border} !important;
        }
    }
    max-height: 48px;

    .brg-input__control {
        background-color: ${({ theme }) => theme.competitionLegalsModal.input.bg};
        border-color: ${({ theme }) => theme.competitionLegalsModal.input.defaultBorder};

        &:hover {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }
        &:focus {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }
        &:active {
            border-color: ${({ theme }) => theme.competitionLegalsModal.input.border};

            .brg-input__placeholder {
                color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
            }
            .brg-input__indicators {
                svg path {
                    fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
                    opacity: 1 !important;
                    transition: none;
                }
            }
        }

    }

    .brg-input__indicator {
        opacity: 1 !important;
        transition: transform 0.2s !important;
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon} !important;
        }
    }

    .brg-input__menu-list {
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
        }

        ::-webkit-scrollbar {
            width: 6px; /* ширина scrollbar */
            height: 61px;
          }
          ::-webkit-scrollbar-track {
            background: transparent; /* цвет дорожки */
          }
          ::-webkit-scrollbar-thumb {
            border-radius: 3px; /* закругления плашки */
            background: #909090;
            border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
            background-clip: padding-box; /* имитация марджина */
          }
        }
    }

    .brg-input__placeholder {
        color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder};
    }

    .brg-input__indicators {
        svg path {
            fill: ${({ theme }) => theme.competitionLegalsModal.input.icon};
            opacity: 1 !important;
            transition: none;
        }
    }

    .brg-input__menu {
        background-color: ${({ theme }) => theme.competitionLegalsModal.input.bg};
    }

    .brg-input__single-value {
        color: ${({ theme }) => theme.competitionLegalsModal.input.color} !important;
    }

    .brg-input__option {
        color: ${({ theme }) => theme.competitionLegalsModal.input.color};
    }
`;

export const ComeAgreeInfo = styled.div`
    color: ${(p) => p.theme.sendProjectsModal.label};
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 10px;
`;

export const FormInfoTitle = styled(FlexBox)`
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: ${({ theme }) => theme.sendProjectsModal.title};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }
`;

export const FormInfoDescription = styled(FlexBox)`
    font-size: 17px;
    line-height: 22px;
    display: inline-block;
    font-weight: 400;
    color: ${({ theme }) => theme.sendProjectsModal.title};

    a {
        color: ${({ theme }) => theme.sendProjectsModal.title};
        text-decoration: underline;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;


export const AgreeWrapper = styled(FlexBox)`
    margin-top: 24px;
    flex-flow: column;

    .checkbox {
        width: 24px;
        height: 24px;
        :hover {
            background: transparent;
        }
    }

    span {
        font-size: 15px;
        line-height: 20px;
        color: ${Colors.galBlack47};

        a {
            text-decoration: underline;
            color: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-top: 34px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin-top: 16px;
    }
`;

export const FormLabel = styled(ProjectEditPageGridLabel)<{ required?: boolean, nowrap?: boolean, labelWidth?: number, labelMargin?: number }>`
    ${({ labelWidth }) => labelWidth && css`
        width: ${labelWidth}px;
        min-width: ${labelWidth}px;
        max-width: ${labelWidth}px;
    `}
    margin-right: ${({ labelMargin }) => labelMargin}px;
    // align-items: flex-start;
    padding-top: 0;

    font-size: 15px;
    line-height: 20px;
    position: relative;
    min-height: 48px;

    ${({ required }) => required && css`
      &::after {
        position: absolute;
        top: 3px;
        right: 15px;
        content: ' *';
        display: contents;
        color: #C64839;
      }
    `};

    .required-label {
        &::after {
            position: absolute;
            top: 50%;
            left: 10%;
            transform: translateY(-50%);
            display: contents;
            content: ' *';
            color: #C64839;
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        ${({ labelWidth }) => labelWidth && css`
            width: ${labelWidth}px;
            min-width: ${labelWidth}px;
        `}
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
    }

  @media(max-width: ${LayoutConst.screen.m}px) {
    height: 20px;
    white-space: ${({ nowrap }) => nowrap ? 'nowrap' : 'wrap'}!important;
  }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        width: 100%;
        max-width: none;
        white-space: pre-wrap !important;
        font-size: 13px;
        line-height: 16px;
        .required-label {
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                left: 102%;
                display: inline;
                content: '*';
            }
    }
    }
`;
export const FormLabelText = styled(FlexBox)<{required?: boolean}>`
    ${({ required }) => required && css`
      &::after {
        position: absolute;
        top: 3px;
        right: 15px;
        content: ' *';
        display: contents;
        color: #C64839;
      }
    `};
`